/**
 * @author mi
 * @date 2018/12/5
 * @project kaoshizhongxin
 */
import Vue from 'vue'
import BeforeClick from './on-before.js'
import OnOutside from './on-outside.js'

Vue.use(BeforeClick)
Vue.use(OnOutside)
